import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ProcessPage } from './pages/ProcessPage';
import { ShowroomPage } from './pages/ShowroomPage';
import { PricingPage } from './pages/PricingPage';
import { QuotePage } from './pages/QuotePage';
import { FAQPage } from './pages/FAQPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { BookingPage } from './pages/BookingPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ScrollToTop } from './components/ScrollToTop';
import { Toaster } from 'sonner';
export function App() {
  return <>
      <Toaster position="top-right" expand={false} richColors data-id="element-0" />
      <Router data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <main className="w-full min-h-screen" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<LandingPage data-id="element-6" />} data-id="element-5" />
            <Route path="/process" element={<ProcessPage data-id="element-8" />} data-id="element-7" />
            <Route path="/showroom" element={<ShowroomPage data-id="element-10" />} data-id="element-9" />
            <Route path="/pricing" element={<PricingPage data-id="element-12" />} data-id="element-11" />
            <Route path="/faq" element={<FAQPage data-id="element-14" />} data-id="element-13" />
            <Route path="/about" element={<AboutPage data-id="element-16" />} data-id="element-15" />
            <Route path="/testimonials" element={<TestimonialsPage data-id="element-18" />} data-id="element-17" />
            <Route path="/book" element={<BookingPage data-id="element-20" />} data-id="element-19" />
            <Route path="/contact" element={<ContactPage data-id="element-22" />} data-id="element-21" />
            <Route path="/get-quote" element={<QuotePage data-id="element-24" />} data-id="element-23" />
            <Route path="/terms" element={<TermsPage data-id="element-26" />} data-id="element-25" />
            <Route path="/privacy" element={<PrivacyPage data-id="element-28" />} data-id="element-27" />
          </Routes>
        </main>
      </Router>
    </>;
}